<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex; flex-wrap: wrap">
        <div></div>
      </div>
      <a-table
        :data-source="table.data"
        :scroll="{ y: 'calc(100vh - 410px)' }"
        row-key="id"
        :column="table.columns"
        style="width: 100%">
        <a-table-column
          data-index="name"
          title="用户名称"
          width="80">
        </a-table-column>
        <a-table-column
          data-index="userId"
          title="用户Id"
          width="80">
        </a-table-column>
        <a-table-column
          data-index="email"
          title="用户邮箱"
          width="80">
        </a-table-column>
        <a-table-column
          data-index="message"
          title="用户留言"
          width="160">
        </a-table-column>
        <a-table-column
          data-index="goodsId"
          title="商品Id"
          width="80">
        </a-table-column>
        <a-table-column
          data-index="goodsName"
          title="商品名称"
          width="80">
        </a-table-column>
        <a-table-column
          data-index="goodsPic"
          title="商品图片"
          width="80">
          <template slot-scope="text,record">
            <img :src="record.goodsPic " width="100" height="100" alt=""/>
          </template>
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION') || '操作'">
          <template slot-scope="text, record">
            <div class="table-operation-wrap">
              <a-button type="link" @click="editTax(record.id)"> {{ $t('EDIT') || '编辑' }}</a-button>
              <a-button type="link" @click="deleteGoodsInquire(record.id)"> {{ $t('DELETE') || '删除' }}</a-button>
            </div>
          </template>
        </a-table-column>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { _delGoodsInquire, _queryGoodsInquire } from '@/api/websiteUserRequest';

async function getInquireList() {
  this.table.loading = true;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryGoodsInquire({
    page: this.table.pagination.current,
    size: this.table.pagination.pageSize,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  this.table.pagination.total = result.totalElements;
  this.table.loading = false;
}
async function deleteGoodsInquire(id) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _delGoodsInquire(id);
      this.$message.success('删除成功');
      await this.getInquireList();
    },
  });
}

export default {
  name: 'WebsiteGoodsInquire',
  components: { },
  data() {
    return {
      searchForm: {
        data: {
          title: '',
          content: '',
          image: '',
        },
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getInquireList,
    deleteGoodsInquire
  },
  created() {
    this.getInquireList();
  },
};
</script>

<style scoped>

</style>
